import { translate } from "app/filters/i18nFilter";
import { IconButton } from "@similarweb/ui-components";
import styled from "styled-components";
import { allTrackers } from "app/services/track/track";
import { showSegmentsMeteringHook } from "app/pages/segments/metering/SegmentsMetering";
import { HOOKS_ICON } from "app/constants/hooks";

const Container = styled.div`
    padding: 0px 0px 0px 4px;
    margin: 4px 0px;
`;

export const customSegmentsSectionHeaderHOF = (onBuildSegmentClick, isLimitationExceeded) =>
    function () {
        const onClick = () => {
            if (isLimitationExceeded) {
                showSegmentsMeteringHook();
                return;
            }

            onBuildSegmentClick();
            allTrackers.trackEvent("Button", "click", `By websites/Create new segment/Has segments`);
        };
        return (
            <Container>
                <IconButton
                    iconName={isLimitationExceeded ? HOOKS_ICON : "add"}
                    type="flat"
                    onClick={onClick}
                >
                    {translate("market.builder.create.new.segment")}
                </IconButton>
            </Container>
        );
    };
